class HistogramDefaultConfig {
    constructor(options) {
        this.title = {
            text: options.histogramTitle
        };

        this.xAxis = {
            categories: options.categories
        };

        this.yAxis = {
            title: {
                text: options.yAxisTitle
            }
        };

        this.plotOptions = {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}',
                }
            }
        };

        this.series = [{
            name: options.seriesName1,
            type: 'column',
            colorByPoint: true,
            data: options.seriesData1
        }]
    }

} export default HistogramDefaultConfig;
